/* eslint-disable mastery/no-dom-manipulation */
import { win } from '@utils/win';

export interface TenantConfig {
  tenantId: string;
  version: number;
  theme: {
    brandColor: string;
    headerBg?: string;
    headerFg?: string;
    [key: string]: string | undefined;
  };
  logo?: {
    file: string;
    altText: string;
  };
  toggleLogo?: {
    file: string;
    altText: string;
  };
}

export const TENANT_THEME_LOADED_EVENT = 'tenantThemeLoaded';

export const getTenantConfig = (): TenantConfig | null => {
  return (win as fixMe).__TENANT_CONFIG__ || null;
};
// ts-unused-exports:disable-next-line
export const getTenantId = (): string => {
  return (win as fixMe).__TENANT_ID__ || 'default';
};
// ts-unused-exports:disable-next-line
export const getTenantStage = (): string => {
  return (win as fixMe).__TENANT_STAGE__ || 'dev';
};
// ts-unused-exports:disable-next-line
export type LogoSize = 'small' | 'medium' | 'large' | 'default';
export type TenantLogoVariant = 'navbar' | 'toggle';
// ts-unused-exports:disable-next-line
export const getTenantLogoUrl = (
  tenantId?: string,
  size: LogoSize = 'default',
  variant: TenantLogoVariant = 'navbar',
): string => {
  const id = tenantId || getTenantId();
  const stage = getTenantStage();
  const config = getTenantConfig();
  const tenantConfig = config?.tenantId === id ? config : null;
  const logoFile =
    variant === 'toggle'
      ? tenantConfig?.toggleLogo?.file ||
        tenantConfig?.logo?.file ||
        'toggle-logo.png'
      : tenantConfig?.logo?.file || 'logo.png';

  const lastDotIndex = logoFile.lastIndexOf('.');
  if (lastDotIndex === -1) {
    const sizedLogoFile = size === 'default' ? logoFile : `${logoFile}-${size}`;
    const baseUrl = getStorageBaseUrl(stage);
    return `${baseUrl}/${stage}/tenants/${id}/${sizedLogoFile}`;
  }

  const filename = logoFile.substring(0, lastDotIndex);
  const ext = logoFile.substring(lastDotIndex + 1);
  const sizedLogoFile =
    size === 'default' ? logoFile : `${filename}-${size}.${ext}`;

  const baseUrl = getStorageBaseUrl(stage);
  return `${baseUrl}/${stage}/tenants/${id}/${sizedLogoFile}`;
};
// ts-unused-exports:disable-next-line
const getStorageBaseUrl = (stage: string): string => {
  const defaultUrl = 'https://connect-carrier.dev.hub.mastermindtms.com';
  const storageMap: { [key: string]: string | undefined } = {
    dev: defaultUrl,
    test: 'https://connect-carrier.test.hub.mastermindtms.com',
    'uat-c': 'https://connect-carrier.uat-c.hub.mastermindtms.com',
    'uat-e': 'https://connect-carrier.uat-e.hub.mastermindtms.com',
    prod: 'https://connect-carrier.hub.mastermindtms.com',
  };

  return storageMap[stage] ?? defaultUrl;
};
// ts-unused-exports:disable-next-line
export const getThemeVar = (varName: string): string => {
  return (
    getComputedStyle(document.documentElement).getPropertyValue(
      `--${varName}`,
    ) || ''
  );
};
// ts-unused-exports:disable-next-line
export const loadTenantTheme = (tenantCode: string): Promise<void> => {
  return new Promise((resolve, reject) => {
    const stage = getTenantStage();
    const baseUrl = getStorageBaseUrl(stage);
    const themeUrl = `${baseUrl}/${stage}/tenants/${tenantCode}/theme.js`;

    const existingScript = document.getElementById('dynamic-tenant-theme');
    if (existingScript) {
      existingScript.remove();
    }

    const script = document.createElement('script');
    script.id = 'dynamic-tenant-theme';
    script.src = themeUrl;
    script.async = false;

    script.onload = (): void => {
      (win as fixMe).__TENANT_ID__ = tenantCode;
      win.dispatchEvent(new CustomEvent(TENANT_THEME_LOADED_EVENT));
      resolve();
    };

    script.onerror = (): void => {
      reject(new Error(`Failed to load theme for tenant: ${tenantCode}`));
    };

    document.head.appendChild(script);
  });
};
